<template>
  <q-bar class="bg-white">
    <div class="col text-center">{{ $t('booking.title') }}</div>
  </q-bar>
  <form ref="form" :action="redirectUrl" method="POST" hidden>
    <input type="text" name="hno" value="101" />
    <input type="text" name="from" :value="form.date.from" />
    <input type="text" name="to" :value="form.date.to" />
    <input type="text" name="room" :value="form.room" />
    <input type="text" name="adult" :value="form.adult" />
    <input type="text" name="child" :value="form.child" />
    <input
      type="text"
      name="callbackUrl"
      value="https://vip.kloudhotel.com.tw/booking/result"
    />
    <input type="text" name="token" :value="token" />
    <input type="text" name="userid" :value="personalInfo.userid" />
    <input type="text" name="lang" :value="lang" />
  </form>
  <div class="row no-wrap">
    <div class="col booking__date items-center text-center">
      <div class="booking__date-title">
        {{ $t('booking.checkInDate') }}
      </div>
      <div class="booking__date-value">
        {{ form.date.from }}
      </div>
      <popup-date-picker :date="form.date" @updateDate="onPickDate" />
    </div>
    <div class="col booking__date items-center text-center">
      <div class="booking__date-title">
        {{ $t('booking.checkOutDate') }}
      </div>
      <div class="booking__date-value">
        {{ form.date.to }}
      </div>
      <popup-date-picker :date="form.date" @updateDate="onPickDate" />
    </div>
  </div>
  <div class="row justify-between q-pa-md">
    <div class="booking__item">{{ $t('booking.room') }}</div>
    <div class="row">
      <q-btn
        round
        outline
        size="sm"
        icon="fas fa-minus"
        :disable="form.room <= 1"
        @click="minusRoom"
      />
      <div class="booking__count">{{ form.room }}</div>
      <q-btn round outline size="sm" icon="fas fa-plus" @click="addRoom" />
    </div>
  </div>
  <div class="row justify-between q-pa-md">
    <div class="booking__item">{{ $t('booking.adult') }}</div>
    <div class="row">
      <q-btn
        round
        outline
        size="sm"
        icon="fas fa-minus"
        :disable="form.adult <= 1"
        @click="minusAdult"
      />
      <div class="booking__count">{{ form.adult }}</div>
      <q-btn round outline size="sm" icon="fas fa-plus" @click="addAdult" />
    </div>
  </div>
  <div class="row justify-between q-pa-md">
    <div class="booking__item">{{ $t('booking.child') }}</div>
    <div class="row">
      <q-btn
        round
        outline
        size="sm"
        icon="fas fa-minus"
        :disable="form.child <= 0"
        @click="minusChild"
      />
      <div class="booking__count">{{ form.child }}</div>
      <q-btn round outline size="sm" icon="fas fa-plus" @click="addChild" />
    </div>
  </div>
  <div class="row q-pa-md">
    <q-btn
      type="submit"
      class="full-width"
      color="primary"
      :label="$t('generic.text.search')"
      :loading="searchLoading"
      @click="onSearch"
    />
  </div>
  <q-dialog v-model="showRoomNotFoundDialog">
    <q-card style="width: 70vw">
      <q-card-section class="items-center">
        <q-list>
          <q-item>
            <q-item-section class="items-center">
              <q-icon name="far fa-file-excel fa-5x text-primary" />
            </q-item-section>
          </q-item>

          <q-item>
            <q-item-section>
              <div class="text-h5 text-center">
                {{ $t('booking.roomNotFound') }}
              </div>
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>

      <q-card-actions align="center">
        <q-btn
          v-close-popup
          class="full-width"
          color="primary"
          :label="$t('generic.text.confirm')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import { RESOURCE_STATE } from '@/constants';
import PopupDatePicker from '@/components/PopupDatePicker.vue';

export default {
  components: {
    PopupDatePicker,
  },
  data() {
    return {
      showRoomNotFoundDialog: false,
      token: '',
      searchingState: RESOURCE_STATE.IDLE,
      redirectUrl:
        'https://booking.kloudhotel.com.tw/Kloudhotel/hotel/reservation/reservation_search_app.php',
      form: {
        date: {
          from: '',
          to: '',
        },
        room: 1,
        adult: 1,
        child: 0,
      },
    };
  },
  computed: {
    ...mapState({
      personalInfo: (state) => state.user.personalInfo,
      lang: (state) => state.lang,
    }),

    searchLoading() {
      return this.searchingState === RESOURCE_STATE.PENDING;
    },
  },
  created() {
    this.form.date.from = this.$moment().format('YYYY/MM/DD');
    this.form.date.to = this.$moment().add(1, 'days').format('YYYY/MM/DD');
    this.token = crypto.randomUUID();
  },
  methods: {
    ...mapMutations({
      setToken: 'user/SET_TOKEN',
    }),
    ...mapActions({
      getAvailableRooms: 'booking/getAvailableRooms',
      updateMemberToken: 'booking/updateMemberToken',
    }),
    onSearch() {
      this.searchingState = RESOURCE_STATE.PENDING;

      this.getAvailableRooms(this.form)
        .then((resp) => {
          if (resp.length <= 0) {
            console.log('no rooms');

            this.showRoomNotFoundDialog = true;
            this.searchingState = RESOURCE_STATE.RESOLVED;
          } else {
            console.log('rooms');
            this.updateMemberToken(this.token)
              .then(() => {
                console.log('go booking');

                this.searchingState = RESOURCE_STATE.RESOLVED;

                this.setToken(this.token);
                this.$refs.form.submit();
              })
              .catch((err) => {
                console.log(err);

                this.searchingState = RESOURCE_STATE.REJECTED;

                this.$notify.create({
                  type: 'negative',
                  position: 'top',
                  message: this.$t('booking.search.failed'),
                  caption: err.response.data,
                });
              });
          }
        })
        .catch((err) => {
          console.log(err);

          this.searchingState = RESOURCE_STATE.REJECTED;

          this.$notify.create({
            type: 'negative',
            position: 'top',
            message: this.$t('booking.search.failed'),
            caption: err.response.data,
          });
        });
    },
    onPickDate(newDate) {
      this.form.date.from = newDate.from;
      this.form.date.to = newDate.to;
    },
    minusRoom() {
      if (this.form.room > 1) {
        this.form.room--;
      }
    },
    addRoom() {
      this.form.room++;
    },
    minusAdult() {
      if (this.form.adult > 1) {
        this.form.adult--;
      }
    },
    addAdult() {
      this.form.adult++;
    },
    minusChild() {
      if (this.form.child > 0) {
        this.form.child--;
      }
    },
    addChild() {
      this.form.child++;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.booking {
  &__date {
    border: 1px solid $text-gray;
    padding: 0.5rem 2rem;
    cursor: pointer;

    &-title {
      font-size: 1.2rem;
      color: $primary;
    }

    &-value {
      font-size: 1.5rem;
    }
  }

  &__item {
    font-size: 1.2rem;
    font-weight: 500;
    color: $text-gray;
    align-self: center;
  }

  &__count {
    font-size: 1.2rem;
    color: $text-gray;
    width: 3rem;
    text-align: center;
    align-self: center;
  }
}
</style>
